import React from 'react';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import MessagePage from '@dashboard/components/pages/MessagePage';

export default function VerificationSuccess() {
  return (
    <MessagePage
      icon="SUCCESS"
      title="Email address verified"
      description="You can now setup templates to send from this verified email address."
      action={
        <ButtonLink href="/" variant="contained" type="submit">
          Get started
        </ButtonLink>
      }
    />
  );
}
